import connect from 'react-redux/es/connect/connect';
import { I18n } from 'react-redux-i18n';

import * as userDetailsActions from '../../../actions/UserDetailsActions';
import * as actions from '../../../actions';
import AmbryIDsTable from '../components/AmbryIDs';
import { MessageBoxTypes } from '../../../const/ActionsConst';


const mapStateToProps = (state, ownProps) => {
    return {
        ...ownProps
    };
};

const mapDispatchToProps = dispatch => {
    return {
        changeOrgName: (name, id, value) => {
            dispatch(userDetailsActions.changeOrgName(name, id, value));
        },
        updateAmbryID: (name, id) => {
            dispatch(userDetailsActions.updateAmbryID(name, id));
        },
        changeClientID: (name, id, value) => {
            dispatch(userDetailsActions.changeClientID(name, id, value));
        },
        addAmbryID: () => {
            dispatch(userDetailsActions.addAmbryPortID());
        },
        removeAmbryID: (id) => {
            const data = { id };
            
            dispatch(actions.showMessageBoxBasedOnData(MessageBoxTypes.DELETE_AMBRY_ID, true, I18n.t('Delete Ambry ID'), I18n.t('Are you sure you want to delete this Ambry ID'), I18n.t('Delete'), I18n.t('Cancel'), 'small', data));
        },
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(AmbryIDsTable);

